import type { ComponentProps } from "react";
import { Loader2Icon } from "lucide-react";
import { useTranslation } from "../../i18n";
import { cn } from "../../lib/utils";

export function Spinner({ className, ...props }: ComponentProps<"svg">) {
  const { t } = useTranslation();
  return <Loader2Icon role="status" aria-label={t("common.loading")} className={cn("size-4 motion-safe:animate-spin", className)} {...props} />;
}
